import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectAppConfig } from 'src/app/core/application-config/application-config.selectors';
import { APPCONFIG_ASSET_PATH, APPCONFIG_FAVICON_OVERRIDE } from 'src/app/shared/enums/application-config.enums';
import { validString } from 'src/app/shared/utilities/types.utils';
import { environment } from '../../../environments/environment';
import { selectDisplayApp } from '../../app.selectors';
import { AppState } from '../../app.state';
import { LocaleService } from '../../core/locale/locale.service';
import { selectNotifications } from '../../core/notification/notification.selectors';
import { NotificationState } from '../../core/notification/notification.state';

@Component({
	selector: 'ahp-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
	/**
	 * The application version
	 */
	version: string = environment.appVersion;
	/**
	 * If we should actually display the application.
	 */
	displayApp$: Observable<boolean>;
	/**
	 * Our notifications.
	 */
	notifications$: Observable<NotificationState>;
	/**
	 * favIcon html element
	 */
	favIcon: HTMLLinkElement = document.querySelector('#favIcon');
	/**
	 * For unsubscribing to observables when the component destroys.
	 */
	private _destroy$ = new Subject<void>();

	/**
	 * @param _store$ The title service
	 * @param title The title service
	 * @param locales The locale service
	 */
	constructor(private _store$: Store<AppState>, title: Title, locales: LocaleService) {
		title.setTitle(locales.get('app.title'));

		this.notifications$ = _store$.select(selectNotifications);
		this.displayApp$ = _store$.select(selectDisplayApp);
	}

	ngOnInit(): void {
		this._store$
			.pipe(
				select(selectAppConfig([APPCONFIG_ASSET_PATH, APPCONFIG_FAVICON_OVERRIDE])),
				takeUntil(this._destroy$)
			)
			.subscribe((appConfigs) => {
				const { assetsPath, faviconOverride } = appConfigs;

				if (validString(assetsPath) && validString(faviconOverride)) {
					this.favIcon.href = assetsPath.concat(faviconOverride);
				}
			});
	}
}
